/**
 * @file The Recipient of a request. A Recipient is a representation of an User in the plannings domain.
 * @author Tom Verschoore de la Houssaije
 */
/**
 * The Recipient of a request.
 * A Recipient is a representation of an User in the plannings domain.
 * @export
 * @class Recipient
 * @implements {Entity}
 */
var Recipient = /** @class */ (function () {
    function Recipient() {
        /**
         * Gets, sets the UserOid property.
         * The UserOid property is a server side NotMapped property.
         * That is why it needs a default value forcing Breeze.js to serialize this property.
         */
        this.UserOid = '?';
    }
    Object.defineProperty(Recipient.prototype, "displayName", {
        /**
         * Gets a name to display in the InputReadByComponent.
         * Returns the EMailAddress as name when FirstName and LastName are both empty.
         * @readonly
         */
        get: function () {
            var name = this.FirstName + ' ' + this.LastName;
            if (name === ' ') {
                return this.EMailAddress;
            }
            return name;
        },
        enumerable: true,
        configurable: true
    });
    return Recipient;
}());
export { Recipient };
